import React from 'react';
import { C } from './shared';
import ColumnToggle from './ColumnToggle';
import { cancelRecalculateAll } from '../../api';

const pill = (extra = {}) => ({
  display: 'inline-flex', alignItems: 'center', gap: 5,
  padding: '4px 12px', borderRadius: 20, fontSize: 12, fontWeight: 500,
  border: `1px solid ${C.border}`, background: '#F1F5F9',
  ...extra,
});

export default function ResultsBar({
  total,
  grandTotal,
  hasFilters,
  favoritesCount,
  showFavoritesOnly,
  onToggleFavorites,
  recalcProgress,
  setRecalcProgress,
  onRecalcAllConfirm,
  visibleColumns,
  onToggleColumn,
  onSelectAllColumns,
  onClearAllColumns,
  colMenuOpen,
  onToggleColMenu,
  checkedIds,
  recalcSelectedProgress,
  onRecalcSelected,
  onRecheckSelected,
  onDeleteSelected,
  onDeleteFiltered,
  deletingFiltered,
  onDeselectAll,
  loading,
  runningBatch,
  settingsSavedAt,
}) {
  const btnSm = {
    padding: '5px 10px', background: 'transparent', color: C.primary,
    border: `1px solid ${C.border}`, borderRadius: 6, fontSize: 12, cursor: 'pointer',
  };

  return (
    <div style={{ padding: '12px 18px', borderBottom: `1px solid ${C.border}` }}>
      <div style={{
        display: 'flex', justifyContent: 'space-between',
        alignItems: 'center', flexWrap: 'wrap', gap: 8,
      }}>
        {/* ── Left: stat pills + bulk actions ── */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
          {/* Загальна кількість в базі (без фільтрів) */}
          <span style={pill()}>
            <span style={{ color: C.textSm }}>In DB</span>
            <span style={{ fontWeight: 700, color: C.text }}>{(grandTotal || total).toLocaleString()}</span>
          </span>

          {/* Знайдено (по фільтру) — тільки якщо активні фільтри */}
          {hasFilters ? (
            <span style={pill({ background: '#EFF6FF', borderColor: '#BFDBFE' })}>
              <span style={{ color: C.textSm }}>Found</span>
              <span style={{ fontWeight: 700, color: C.primary }}>{total.toLocaleString()}</span>
            </span>
          ) : null}

          {/* Recalculate selected */}
          {checkedIds.size > 0 && !recalcSelectedProgress && (
            <>
              <button
                style={{ ...btnSm, color: C.primary, borderColor: C.primary, fontWeight: 600 }}
                onClick={onRecalcSelected}
              >
                🔄 Recalculate ({checkedIds.size})
              </button>
              <button
                style={{ ...btnSm, color: '#6D28D9', borderColor: '#7C3AED', fontWeight: 600 }}
                onClick={onRecheckSelected}
                title="Прогнати ці рядки на свіжому наборі перевірочних вікон. Рахує парк: скільки рядків — стільки машин задіється. Вікна дописуються в самі рядки."
              >
                🎲 Перевірити ({checkedIds.size})
              </button>
              <button
                style={{ ...btnSm, color: C.danger, borderColor: C.danger, fontWeight: 600 }}
                onClick={onDeleteSelected}
              >
                🗑 Delete ({checkedIds.size})
              </button>
            </>
          )}
          {recalcSelectedProgress && (
            recalcSelectedProgress.status === 'loading' ? (
              <span style={{ fontSize: 12, color: C.warning }}>⏳ Loading data…</span>
            ) : recalcSelectedProgress.status === 'completed' ? (
              <span style={{ fontSize: 12, color: C.success }}>✓ Done</span>
            ) : (
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: C.textMd }}>
                <div style={{ width: 100, height: 6, background: C.border, borderRadius: 3, overflow: 'hidden' }}>
                  <div style={{
                    width: `${recalcSelectedProgress.progress || 0}%`,
                    height: '100%', background: C.primary, transition: 'width 0.3s',
                  }} />
                </div>
                <span>{recalcSelectedProgress.current} / {recalcSelectedProgress.total}</span>
              </div>
            )
          )}
          {checkedIds.size > 0 && (
            <button style={{ ...btnSm, color: C.textMd }} onClick={onDeselectAll}>
              ✕ Deselect
            </button>
          )}
        </div>

        {/* ── Right: Recalculate All + saved indicator + Columns ── */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          {loading && runningBatch && (
            <span style={{ fontSize: 12, color: C.warning }}>
              ⏳ Running {runningBatch.count} combo(s)…
            </span>
          )}

          {/* Recalculate All */}
          {/* {recalcProgress && (recalcProgress.status === 'running' || recalcProgress.status === 'loading') ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: C.textMd }}>
              <div style={{ width: 120, height: 6, background: C.border, borderRadius: 3, overflow: 'hidden' }}>
                <div style={{
                  width: `${recalcProgress.progress}%`, height: '100%',
                  background: C.primary, transition: 'width 0.3s',
                }} />
              </div>
              <span>{recalcProgress.current} / {recalcProgress.total} ({recalcProgress.progress}%)</span>
              <button
                style={{ ...btnSm, background: '#dc2626', color: '#fff', border: 'none' }}
                onClick={async () => { try { await cancelRecalculateAll(); } catch (_) {} }}
              >
                ✕ Stop
              </button>
            </div>
          ) : recalcProgress?.status === 'completed' ? (
            <span style={{ fontSize: 12, color: C.success }}>✓ Recalculated</span>
          ) : recalcProgress?.status === 'cancelled' ? (
            <span style={{ fontSize: 12, color: '#f59e0b' }}>⏹ Stopped</span>
          ) : (
            <button style={btnSm} onClick={onRecalcAllConfirm} disabled={total === 0}>
              🔄 Recalculate All
            </button>
          )} */}

          {settingsSavedAt && (
            <span style={{ fontSize: 11, color: C.success }}>✓ Saved</span>
          )}

          {/* Delete all filtered — на правому боці, подалі від Favorites */}
          {hasFilters && total > 0 && (
            deletingFiltered ? (
              <span style={{ fontSize: 12, color: C.danger, display: 'flex', alignItems: 'center', gap: 6 }}>
                <span style={{
                  width: 12, height: 12, borderRadius: '50%',
                  border: `2px solid ${C.danger}`, borderTopColor: 'transparent',
                  display: 'inline-block', animation: 'spin 0.7s linear infinite',
                }} />
                Видалення…
              </span>
            ) : (
              <button
                style={{ ...btnSm, color: C.danger, borderColor: '#FECACA', fontWeight: 500 }}
                onClick={onDeleteFiltered}
              >
                🗑 Delete filtered ({total.toLocaleString()})
              </button>
            )
          )}

          <ColumnToggle
            visible={visibleColumns}
            onToggle={onToggleColumn}
            onSelectAll={onSelectAllColumns}
            onClearAll={onClearAllColumns}
            isOpen={colMenuOpen}
            onToggleOpen={onToggleColMenu}
          />
        </div>
      </div>
    </div>
  );
}
